import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/terms-of-service/PageContent.tsx");
